import React, { useState, useRef, useEffect } from "react";
import { RxCross2 } from "react-icons/rx";
import { MdOutlineMailOutline } from "react-icons/md";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { verifyRegisterOtp } from "../API/Api";
import LoginModal from "./LoginModal/LoginModal";

const RegisterModal = ({ isOpen, onClose, email }) => {
    const [otp, setOtp] = useState(Array(6).fill(""));
    const [isVerifying, setIsVerifying] = useState(false);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const inputRefs = useRef([]);

    useEffect(() => {
        if (!isOpen) {
            setOtp(Array(6).fill(""));
            setIsVerifying(false);
            setShowLoginModal(false);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleChange = (index, value) => {
        if (/^[0-9]$/.test(value) || value === "") {
            const newOtp = [...otp];
            newOtp[index] = value;
            setOtp(newOtp);

            if (value && index < 5) {
                inputRefs.current[index + 1].focus();
            }
        }
    };

    const handleKeyDown = (index, e) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputRefs.current[index - 1].focus();
        }
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData('text/plain').slice(0, 6);
        if (/^\d+$/.test(pasteData)) {
            const newOtp = [...otp];
            pasteData.split('').forEach((char, i) => {
                if (i < 6) newOtp[i] = char;
            });
            setOtp(newOtp);
            if (pasteData.length < 6) {
                inputRefs.current[pasteData.length].focus();
            }
        }
    };

    const handleVerify = async () => {
        const otpCode = otp.join('');
        if (otpCode.length !== 6) {
            toast.error('Please enter a 6-digit OTP code');
            return;
        }
        setIsVerifying(true);
        try {
            const response = await verifyRegisterOtp(email, otpCode);

            if (!response) {
                throw new Error('Server did not respond');
            }
            toast.success('Registration successful! Please login to continue.');
                        setTimeout(() => {
                onClose();
                setShowLoginModal(true);
            }, 1500);
            
        } catch (error) {
            toast.error(error.response?.data?.message || error.message);
        } finally {
            setIsVerifying(false);
        }
    };

    
    return (
        <>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                closeOnClick
                pauseOnHover
            />

            <div className="forgetEmailOverlay">
                <div className="forgetEmailModal">
                    <div className="circleIconContainer">
                        <MdOutlineMailOutline className="emailIcon" />
                    </div>

                    <div className="headerforgets">
                        <h2 className="forgetTitle">Check your email</h2>
                    </div>
                    <p className="forgetText">
                        We've sent a 6-digit OTP to your email address. Please check your inbox.
                    </p>

                    <div className="otpContainer">
                        {[...Array(6)].map((_, index) => (
                            <input
                                key={index}
                                type="text"
                                maxLength="1"
                                className="otpInput"
                                value={otp[index]}
                                onChange={(e) => handleChange(index, e.target.value)}
                                onKeyDown={(e) => handleKeyDown(index, e)}
                                onPaste={handlePaste}
                                ref={(el) => (inputRefs.current[index] = el)}
                                autoFocus={index === 0}
                                disabled={isVerifying}
                            />
                        ))}
                    </div>
                    <div className="resendContainer">
                        <p className="resendText">
                            {"Didn't get the code? Resend Code"}
                        </p>
                    </div>

                    <button
                        className="loginBtn"
                        onClick={handleVerify}
                        disabled={isVerifying}
                    >
                        {isVerifying ? "Verifying..." : "VERIFY"}
                    </button>
                    <button className="closeModalBtn" onClick={onClose} disabled={isVerifying}>
                        <RxCross2 />
                    </button>
                </div>
            </div>

            <LoginModal
                isOpen={showLoginModal}
                onClose={() => setShowLoginModal(false)}
                initialEmail={email}
            />
        </>
    );
};

export default RegisterModal;